export const UPDATE_VEHICLE_INFO = 'UPDATE_VEHICLE_INFO';
export const FETCH_CVI_VEHICLE_REQUEST = 'FETCH_CVI_VEHICLE_REQUEST';
export const FETCH_CVI_VEHICLE_SUCCESS = 'FETCH_CVI_VEHICLE_SUCCESS';
export const FETCH_CVI_VEHICLE_FAILURE = 'FETCH_CVI_VEHICLE_FAILURE';
export const SHOW_EDIT_VEHICLE = 'SHOW_EDIT_VEHICLE';
export const HIDE_EDIT_VEHICLE = 'HIDE_EDIT_VEHICLE';
export const UPDATE_CVI_PRICING = 'UPDATE_CVI_PRICING';
export const REQUOTE_AFTER_GUARDED_VEHICLE_SWITCH = 'REQUOTE_AFTER_GUARDED_VEHICLE_SWITCH';
export const DISMISS_CASH_FALLBACK_NOTICE = 'DISMISS_CASH_FALLBACK_NOTICE';

// Analytics-only (no reducer): drives the CDL v3 Pixall tag for the Inventory Type selector (dc-mv-326).
export const INVENTORY_TYPE_SELECT_CLICKED = 'INVENTORY_TYPE_SELECT_CLICKED';
